(function () {
  // Mark collection pages so the phone spacing only applies there
  if (location.pathname.indexOf('/collections/') === 0) {
    document.documentElement.classList.add('dd-coll');
  }

  var cache = {};

  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return '';
    return (a.getAttribute('href').split('/products/')[1] || '').split(/[?#/]/)[0];
  }

  // One fetch per product, shared by the restocking and in-stock checks
  function getProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  // Restocking = the product carries the tag: restocking
  function isRestocking(handle) {
    return getProduct(handle).then(function (p) {
      if (!p || !p.tags) return false;
      var tags = Array.isArray(p.tags) ? p.tags : String(p.tags).split(',');
      return tags.some(function (t) { return String(t).trim().toLowerCase() === 'restocking'; });
    });
  }

  function commonAncestor(a, b) {
    var n = a;
    while (n && !n.contains(b)) n = n.parentElement;
    return n;
  }

  // Green "in stock" tag, only on cards that have no other tag and are available
  function addInStock(card) {
    if (card.hasAttribute('data-dd-instock')) return;
    card.setAttribute('data-dd-instock', '1');
    getProduct(handleOf(card)).then(function (p) {
      if (!p || !p.available) return;
      if (card.querySelector('.dd-instock')) return;

      var host = card.querySelector('.card-gallery');
      if (!host) {
        var img = card.querySelector('img');
        host = img ? img.parentElement : null;
      }
      if (!host) return;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

      var wrap = document.createElement('div');
      wrap.className = 'dd-instock-wrap';
      var tag = document.createElement('span');
      tag.className = 'dd-instock';
      tag.textContent = 'in stock';
      wrap.appendChild(tag);
      host.appendChild(wrap);
    });
  }

  // Labels: "Sold out" becomes red, or orange "restocking soon.." when tagged restocking.
  // Other badges (sale) are revealed as they are. No badge at all and available = green "in stock".
  function labels(card) {
    var leaves = Array.prototype.filter.call(card.querySelectorAll('[class*="badge"]'), function (b) {
      return !b.querySelector('[class*="badge"]');
    });

    var badges = [];
    leaves.forEach(function (b) {
      if (/sold out/i.test(b.textContent)) badges.push(b);
      else b.classList.add('dd-other');
    });

    if (!leaves.length) { addInStock(card); return; }
    if (!badges.length) return;

    badges.forEach(function (b) { b.style.visibility = 'hidden'; });
    isRestocking(handleOf(card)).then(function (restocking) {
      badges.forEach(function (b) {
        if (restocking) {
          b.textContent = 'restocking soon..';
          b.classList.add('dd-restock');
        } else {
          b.classList.add('dd-sold');
        }
        b.style.visibility = '';
      });
    });
  }

  // Row: name on the left, price on the right. Only these two pieces move, never the photo.
  function priceRow(card) {
    if (card.querySelector('.dd-row')) return;

    var links = card.querySelectorAll('a[href*="/products/"]');
    var title = null;
    for (var i = 0; i < links.length; i++) {
      if (links[i].textContent.trim() && !links[i].querySelector('img')) { title = links[i]; break; }
    }
    var price = card.querySelector('product-price, .price');
    if (!title || !price) return;

    var top = commonAncestor(title, price);
    if (!top || top === title || top === price) return;

    var t = title, p = price;
    while (t.parentElement && t.parentElement !== top) t = t.parentElement;
    while (p.parentElement && p.parentElement !== top) p = p.parentElement;
    if (t === p) return;
    if (t.querySelector('img') || p.querySelector('img')) return;

    var row = document.createElement('div');
    row.className = 'dd-row';
    var first = (t.compareDocumentPosition(p) & Node.DOCUMENT_POSITION_FOLLOWING) ? t : p;
    top.insertBefore(row, first);
    row.appendChild(t);
    row.appendChild(p);
  }

  function process(card) {
    if (card.hasAttribute('data-dd-done')) return;
    if (!card.querySelector('a[href*="/products/"]')) return;
    card.setAttribute('data-dd-done', '1');
    labels(card);
    priceRow(card);
  }

  function run() {
    document.querySelectorAll('product-card, .product-card').forEach(process);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; run(); });
  }

  function start() {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();